import React, { useState } from "react";
import { FRONT_URL } from "../../../consts";
import { copyTextToClipboard } from "../../../util";


const LoyaltyRef = ({ profile }) => {

    const [isHovered1, setIsHovered1] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);

    const [isCopied, setIsCopied] = useState(false);
    const linkToCopy = `${FRONT_URL}/registration?ref=${profile._id}`;


    const handleCopy = () => {
        copyTextToClipboard(linkToCopy);
        setIsCopied(true);
        setTimeout(() => {
            setIsCopied(false);
        }, 2000);
    };

    return (
        <div className="min-h-[250px] xl:h-auto h-full w-[100%] py-[16px] px-[20px] pb-[26px] rounded-[15px]" style={{ backgroundColor: '#fff' }}>
            <div className="flex xl:flex-row flex-col xl:justify-between xl:gap-[60px]">

                <div className="xl:w-[50%]">
                    <div className="font-semibold mb-[12px] sm:text-[20px] text-[18px]">
                        Приведи друга и получи бонус
                    </div>
                    <div className="  flex  gap-[20px]   mb-[10px]">
                        <div>
                            <div className="font-normal text-[14px] mb-[5px]"
                                style={{
                                    color: '#6A6D6F'
                                }}>
                                Вы привлекли
                            </div>
                            <div className="font-extrabold text-[20px]"
                                style={{
                                    color: '#C3372E'
                                }}>
                                {profile.invited_friends.length} друзей
                            </div>
                        </div>
                        <div>
                            <div className="font-normal text-[14px] mb-[5px]"
                                style={{
                                    color: '#6A6D6F'
                                }}>
                                Баллы
                            </div>
                            <div className="font-extrabold text-[20px]"
                                style={{
                                    color: '#C3372E'
                                }}>
                                {profile.bonuspoints}
                            </div>
                        </div>
                    </div>
                    <div className="mb-[5px] xl:mb-0">
                        <a href="#" className={`text-[14px] transition duration-300 ${isHovered1 ? 'no-underline' : 'underline'}`}
                            style={{
                                color: '#C3372E',
                            }}
                            onMouseEnter={() => setIsHovered1(true)}
                            onMouseLeave={() => setIsHovered1(false)}>
                            Посмотреть историю  начислений</a>
                    </div>
                </div>

                <div className="xl:w-[50%] mb-[5px] xl:mb-0 w-full text-[12px] sm:text-[14px] border-[1px] border-dashed rounded-[15px] p-[15px] leading-[1.3]"
                    style={{
                        borderColor: '#C3372E'
                    }}>
                    <div className="pb-[7px] ">
                        Пригласите друзей и получайте бонусы:
                        <span className="font-bold"> 50 баллов за регистрацию и 100 баллов за первый заказ!</span>
                    </div>
                    <div className="flex justify-between gap-[20px] items-center">
                        <div className="pt-[7px] border-t-[1px] border-dashed"
                            style={{
                                borderColor: '#C3372E',
                            }}>
                            Ваш друг также получит скидку
                            <span className="font-bold"> 10% на первый заказ!</span>
                        </div>
                        <div>
                            <img className="w-[60px]" src="/img/lk/lkLoyalty/bonus.svg" />
                        </div>
                    </div>
                </div>

            </div>

            <div>
                <div className="mb-[4px]">
                    Ваша реферальная ссылка
                </div>
                <div className="flex items-center gap-[10px] justify-between">
                    <div className="sm:px-[16px] truncate sm:py-[15px]  p-[10px] border-solid border-[1px] rounded-[35px] text-[16px] sm:text-[20px] font-bold w-full"
                        style={{
                            borderColor: '#DDDDDD',
                            color: '#6A6D6F'
                        }}>
                        {isCopied ? 'Ссылка скопированна' : linkToCopy}
                    </div>
                    <div>
                        <button className="rounded-[35px] p-[16px] transition duration-300"
                            style={{
                                backgroundColor: isHovered2 ? '#A32A25' : '#C3372E'
                            }}
                            onMouseEnter={() => setIsHovered2(true)}
                            onMouseLeave={() => setIsHovered2(false)}
                            onClick={() => handleCopy()}>
                            <img className="w-[25px] block" src="/img/lk/lkLoyalty/copyBtn.svg" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LoyaltyRef;
